var version = {
    "name":      "dativery",
    "buildDateCode": "20251216-190004",
    "buildDate": "Tue Dec 16 2025 19:00:04 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20251216-190004",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;